import "./AIZoneSearchBar.css";
import { attachLanguageAltInput, readAyeInputLanguage } from "./LanguageAltInput";

export interface AIZoneSearchBarProps {
  onSend: (query: string) => void;
  placeholder?: string;
  isChatMode?: boolean;
}

export function renderAIZoneSearchBar(
  container: HTMLElement,
  onSend: (query: string) => void,
  placeholder = "Ask anything...",
  isChatMode = true,
) {
  container.innerHTML = `
    <div class="ai-search-container ${isChatMode ? "chat-mode" : ""}">
      <div class="search-header-label">Ask anything</div>

      <div class="search-input-wrapper">
        <span class="ai-plus-icon">＋</span>
        
        <textarea 
          id="ai-textarea" 
          rows="1" 
          placeholder="${placeholder}"
        ></textarea>

        <button class="ai-send-btn" id="ai-send-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M7 11L12 6L17 11M12 18V7" 
              stroke="currentColor" 
              stroke-width="2" 
              stroke-linecap="round" 
              stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </div>
  `;

  setupSearchBarEvents(container, onSend);
}

function setupSearchBarEvents(
  container: HTMLElement,
  onSend: (query: string) => void,
) {
  const textarea = container.querySelector(
    "#ai-textarea",
  ) as HTMLTextAreaElement | null;
  const sendBtn = container.querySelector("#ai-send-btn");

  if (!textarea || !sendBtn) return;

  // AI Zone and its expanded/chat state share this same component, so both
  // automatically get the selected AyeSearch language Alt-character helper.
  attachLanguageAltInput(textarea, {
    getLanguage: readAyeInputLanguage,
  });

  const autoResize = () => {
    textarea.style.height = "auto";
    const maxHeight = 200;

    if (textarea.scrollHeight <= maxHeight) {
      textarea.style.height = textarea.scrollHeight + "px";
      textarea.style.overflowY = "hidden";
    } else {
      textarea.style.height = maxHeight + "px";
      textarea.style.overflowY = "auto";
    }
  };

  textarea.addEventListener("input", autoResize);

  const sendMessage = () => {
    const text = textarea.value.trim();
    if (!text) return;

    onSend(text);
    textarea.value = "";
    autoResize();
  };

  sendBtn.addEventListener("click", sendMessage);

  textarea.addEventListener("keydown", (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendMessage();
    }
  });

  setTimeout(autoResize, 10);
}
